import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import Dashboard from '../assets/NavIcon/dashboard.svg';
import DashboardWhite from '../assets/NavIcon/dashboardWhite.svg';
import BatchClass from '../assets/NavIcon/BatchClass.svg';
import BatchClassWhite from '../assets/NavIcon/BatchClassWhite.svg';
import Calendar from '../assets/NavIcon/Calendar.svg';
import CalendarWhite from '../assets/NavIcon/CalendarWhite.svg';
import CbseClass from '../assets/NavIcon/CbseClass.svg';
import CbseClassWhite from '../assets/NavIcon/CbseClassWhite.svg';
import ClassMaterial from '../assets/NavIcon/ClassMaterial.svg';
import ClassMaterialWhite from '../assets/NavIcon/ClassMaterialWhite.svg';
import DigitalClassroom from '../assets/NavIcon/DigitalClassroom.svg';
import DigitalClassroomWhite from '../assets/NavIcon/DigitalClassroomWhite.svg';
//import DigitalDiscussion from '../assets/NavIcon/DigitalDiscussion.svg';
import DoubtCounter from '../assets/NavIcon/DoubtCounter.svg';
import DoubtCounterWhite from '../assets/NavIcon/DoubtCounterWhite.svg';
import LiveClass from '../assets/NavIcon/LiveClass.svg';
import LiveClassWhite from '../assets/NavIcon/LiveClassWhite.svg';
import Race from '../assets/NavIcon/Race.svg';
import RaceWhite from '../assets/NavIcon/RaceWhite.svg';
import AddonClass from '../assets/NavIcon/AddonClass.svg';
import AddonClassWhite from '../assets/NavIcon/AddonClassWhite.svg';
import Download from '../assets/NavIcon/Download.svg';
import DownloadWhite from '../assets/NavIcon/DownloadWhite.svg';
import Homework from '../assets/NavIcon/Homework.svg';
import HomeworkWhite from '../assets/NavIcon/HomeworkWhite.svg';
import NoticeBoard from '../assets/NavIcon/NoticeBoard.svg';
import NoticeBoardWhite from '../assets/NavIcon/NoticeBoardWhite.svg';
import PerformanceReport from '../assets/NavIcon/PerformanceReport.svg';
import PerformanceReportWhite from '../assets/NavIcon/PerformanceReportWhite.svg';
import TestPerformanceAnalysis from '../assets/NavIcon/TestPerformanceAnalysis.svg';
import TestPerformanceAnalysisWhite from '../assets/NavIcon/TestPerformanceAnalysisWhite.svg';
import ExaminationHall from '../assets/NavIcon/ExaminationHall.svg';
import ExaminationHallWhite from '../assets/NavIcon/ExaminationHallWhite.svg';
import LiveWebinar from '../assets/NavIcon/LiveWebinar.svg';
import LiveWebinarWhite from '../assets/NavIcon/LiveWebinarWhite.svg';
import TextMessages from '../assets/NavIcon/TextMessages.svg';
import TextMessagesWhite from '../assets/NavIcon/TextMessagesWhite.svg';
import LiveDoubtClass from '../assets/NavIcon/LiveDoubtClass.svg';
import LiveDoubtClassWhite from '../assets/NavIcon/LiveDoubtClassWhite.svg';
import GroupNotification from '../assets/NavIcon/GroupNotification.svg';
import GroupNotificationWhite from '../assets/NavIcon/GroupNotificationWhite.svg';

import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';

const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
    color: theme.palette.common.black
  },
  tooltip: {
    backgroundColor: theme.palette.common.black
  }
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow classes={classes} {...props} />;
}

export default function Navigation(props) {
  let [hover, setHover] = useState({});
  const menuItems = useSelector(state =>
    get(state, 'loginReducer.listLink', [])
  );

  const getMenuDetails = val => {
    console.log("get menu details doubt counter value -- ", val);
    switch (val) {
      case 'notice':
        return {
          icon: NoticeBoard,
          iconWhite: NoticeBoardWhite,
          url: 'notice-board'
        };
      case 'digital':
        return {
          icon: DigitalClassroom,
          iconWhite: DigitalClassroomWhite,
          url: 'digital-classroom'
        };
      case 'digital-class-material':
        return {
          icon: ClassMaterial,
          iconWhite: ClassMaterialWhite,
          url: 'classroom-material'
        };
      case 'examinationahall':
        return {
          icon: ExaminationHall,
          iconWhite: ExaminationHallWhite,
          url: 'exam-hall'
        };
      case 'webinar':
        return {
          icon: LiveWebinar,
          iconWhite: LiveWebinarWhite,
          url: 'live-webinar'
        };
      case 'digital-doubt':
        return {
          icon: LiveClass,
          iconWhite: LiveClassWhite,
          url: 'digital-liveclass'
        };
      case 'digitalliverecord':
        return {
          icon: LiveClass,
          iconWhite: LiveClassWhite,
          url: 'live-class-recordings'
        };
      case 'livedoubtclass':
        return {
          icon: LiveDoubtClass,
          iconWhite: LiveDoubtClassWhite,
          url: 'live-doubt-class'
        };
      case 'class-schedule':
        return {
          icon: BatchClass,
          iconWhite: BatchClassWhite,
          url: 'batch-class-schedule'
        };
      case 'exam-calendar':
        return {
          icon: Calendar,
          iconWhite: CalendarWhite,
          url: 'regular-exam-calendar'
        };
      case 'test-performance':
        return {
          icon: TestPerformanceAnalysis,
          iconWhite: TestPerformanceAnalysisWhite,
          url: 'test-performance-analysis'
        };
      case 'student-performance-report':
        return {
          icon: PerformanceReport,
          iconWhite: PerformanceReportWhite,
          url: 'performance-report'
        };
      case 'exercise-race':
        return {
          icon: Race,
          iconWhite: RaceWhite,
          url: 'exercise-race'
        };
      case 'download':
        return {
          icon: Download,
          iconWhite: DownloadWhite,
          url: 'download-material'
        };
      case 'digital-class-homework':
        return {
          icon: Homework,
          iconWhite: HomeworkWhite,
          url: 'homework'
        };
      case 'message':
        return {
          icon: TextMessages,
          iconWhite: TextMessagesWhite,
          url: 'text-messages'
        };

      case 'student-g':
        return {
          icon: GroupNotification,
          iconWhite: GroupNotificationWhite,
          url: 'group-notifications'
        };
      case 'addon-classes':
        return {
          icon: AddonClass,
          iconWhite: AddonClassWhite,
          url: 'addon-classes'
        };
      case 'cbse-classes':
        return {
          icon: CbseClass,
          iconWhite: CbseClassWhite,
          url: 'cbse-classes'
        };
      case 'doubt-dashboard':
        return {
          icon: DoubtCounter,
          iconWhite: DoubtCounterWhite,
          url: 'digital-doubt-counter'
        };

      default:
        return {
          icon: TextMessages,
          iconWhite: TextMessagesWhite,
          url: 'text-messages'
        };
    }
  };

  const populateMenuItems = () => {
    let menuList = [];
    (menuItems || []).map(item => {
      if (
        item.LinkCode != 'dashboard' &&
        item.LinkCode != 'profile' &&
        item.showOnWeb
      )
        menuList.push(
          <Link
            to={`/${getMenuDetails(item.LinkCode).url}`}
            className="navigation-item"
            style={{ borderLeft: '0px' }}
            onMouseOver={() => setHover({ ...hover, [item.LinkCode]: true })}
            onMouseOut={() => setHover({ ...hover, [item.LinkCode]: false })}
          >
            <BootstrapTooltip
              title={item.ToolTip}
              placement="bottom"
              disableHoverListener={props.disableHoverListener || false}
            >
              <div className="content">
                <span className="icon">
                  <img
                    width="30px"
                    height="30px"
                    src={
                      hover[item.LinkCode]
                        ? getMenuDetails(item.LinkCode).iconWhite
                        : getMenuDetails(item.LinkCode).icon
                    }
                  />
                </span>
                <span className="menu-text">{item.LinkTitle}</span>
              </div>
            </BootstrapTooltip>
          </Link>
        );
    });
    return <>{menuList}</>;
  };

  return (
    <div className="navigation">
      <Link
        to="/"
        className="navigation-item dashboard"
        onMouseOver={() => setHover({ ...hover, Dashboard: true })}
        onMouseOut={() => setHover({ ...hover, Dashboard: false })}
      >
        <BootstrapTooltip
          title="Click here, To go to Dashboard Page"
          placement="bottom"
          disableHoverListener={props.disableHoverListener || false}
        >
          <div className="content">
            <span className="icon">
              <img
                width="30px"
                height="30px"
                src={hover.Dashboard ? DashboardWhite : Dashboard}
              />
            </span>
            <span className="menu-text">Dashboard</span>
          </div>
        </BootstrapTooltip>
      </Link>
      {populateMenuItems()}
    </div>
  );
}

Navigation.propTypes = {
  disableHoverListener: PropTypes.bool
};
